export const additionaloptions = [
  {
    id: '27',
    label: '10% - Aguas minerales y bebidas analcohólicas ',
    value: 10
  },
  {
    id: '23',
    label: '15% - Art. De oro, Joyas y Pieles finas',
    value: 15
  },
  {
    id: '26',
    label: '20.5% - Cervezas y otras bebidas alcohólicas',
    value: 20.5
  },
  {
    id: '24',
    label: '31.5% - Licores, pisco, destilados',
    value: 31.5
  },
  {
    id: '44',
    label: '15% - Tapices, Casas Rodantes, Caviar y Arm. De air',
    value: 15
  },
  {
    id: '25',
    label: '20.5% - Vinos, chichas, sidras',
    value: 20.5
  },
];
